import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { CAMPAIGN_INTERNAL_STATUSES } from 'shared/constants'
import { updateCampaignExtraData } from '../../gql/updateCampaignInternalStatus'
import ConfirmationPopup from '../Popups/ConfirmationPopup'
import styles from './styles'

const OverrideCampaignStatusSection = ({
  classes,
  isButtonActive,
  setCampaignStatus,
  codesRefetch,
}) => {
  const { campaignId } = useParams()
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const onChangeStatus = async () => {
    setIsLoading(true)
    const response = await updateCampaignExtraData({
      campaignId: campaignId,
      internalStatus: CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW,
    })
    const result = await response.json()

    setCampaignStatus(result.data.updateCampaignExtraData.internalStatus)
    await codesRefetch()
    setIsLoading(false)
    setIsConfirmationModalOpen(false)
  }

  return (
    <React.Fragment>
      <ConfirmationPopup
        onCancel={() => {
          setIsConfirmationModalOpen(false)
        }}
        isOpen={isConfirmationModalOpen}
        onConfirm={onChangeStatus}
        body={
          <div>
            <div className={classes.modalInfo}>
              The campaign is currently in status Upload Codes, which means that
              only client can upload, delete & submit client codes.
            </div>
            <div className={classes.modalInfo}>
              By moving the campaign to Code Review,
              <div className={classes.bold}>
                client will not be able to do anything.
              </div>
              Instead, admin will be able to upload & delete both client codes &
              internal codes.
            </div>
            <div className={classes.modalInfo}>
              Override is useful if client is unable to upload codes themselves
              and admin does it on their behalf.
            </div>
          </div>
        }
        title="Confirm override"
        isInProgress={isLoading}
      />
      <div className={classes.block}>
        <div className={classes.header}>
          <div>Override campaign status to Code Review</div>
        </div>
        <div className={classes.content}>
          By manually moving the campaign from Upload Codes to Code Review,
          admin will be able to upload and delete any codes.
        </div>
        <Button
          className={classes.button}
          variant="outlined"
          disabled={!isButtonActive}
          onClick={() => setIsConfirmationModalOpen(true)}
        >
          Override Campaign Status
        </Button>
      </div>
    </React.Fragment>
  )
}

export default withStyles(styles)(OverrideCampaignStatusSection)
